import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import { AuthenticationReducer as Authentication } from '../../commons/reduxModules/Authentication';

import { APIOrgasReducer as APIOrgas } from '../../commons/reduxModules/APIOrgas';
import { APIEventTypesReducer as APIEventTypes } from '../../commons/reduxModules/APIEventTypes';
import { APIMeReducer as APIMe } from '../../commons/reduxModules/APIMe';

import Notifications from '../../reducers/Notifications';

import AppFormContact from './App';

export default function getReducer(history) {
    return combineReducers({
        // Globals
        router: connectRouter(history),
        Authentication,
        Notifications,
        // API Reducers
        APIOrgas,
        APIEventTypes,
        APIMe,
        // App Reducer
        AppFormContact,
    });
}
